export function getViteAppOktaBaseUrl(): string {
  return import.meta.env.VITE_OKTA_BASE_URL;
}
